<template>
    <div>
        <b-row>
            <b-col sm="12" md="12" lg="12" xl="12">
                <b-card no-body>
                    <b-card-header>
                        <span class="h5">
                            DADOS CADASTRAIS -
                            <b-badge variant="warning">{{ operacao }}</b-badge>
                        </span>
                    </b-card-header>
                    <b-card-body>
                        <app-erros-box
                            :erros="erros"
                            v-if="erros.length > 0"
                        ></app-erros-box>
                        <b-row>
                            <b-col sm="12" md="12">
                                <b-form-group>
                                    <label class="required">Logo</label>
                                    <div class="d-flex align-items-center">
                                        <img :src="logo.preview" alt="Logo" class="mr-3" style="width: 150px; height: 150px; object-fit: contain;">
                                        <div class="d-flex flex-column align-items-start">
                                            <div class="d-flex">
                                                <b-button @click="triggerLogoUpload" variant="primary" class="mr-2">
                                                    Selecionar Arquivo
                                                </b-button>
                                                <b-button @click="removeLogo" variant="danger" v-if="logo.preview && logo.preview !== 'img/placeholder-logo.png'">
                                                    Remover Logo
                                                </b-button>
                                            </div>
                                            <input type="file" ref="logoFileInput" @change="handleLogoChange" accept="image/png, image/svg+xml" class="d-none">
                                            <small class="form-text text-muted mt-2">
                                                A imagem deve ter no máximo 1024x1024px e 2MB.
                                            </small>
                                            <b-form-invalid-feedback :state="!logoError">
                                                {{ logoError }}
                                            </b-form-invalid-feedback>
                                            <b-form-invalid-feedback :force-show="$v.logo.preview.$invalid">
                                                Logomarca obrigatória.
                                            </b-form-invalid-feedback>
                                        </div>                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="12" md="4" lg="4" xl="4">
                                <b-form-group>
                                    <label>CNPJ</label>
                                    <b-input-group>
                                        <b-form-input
                                            type="text"
                                            v-model="fornecedor.cpfCnpj"
                                            :disabled="desabilitarCampo"
                                        ></b-form-input>
                                    </b-input-group>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4" xl="4">
                                <b-form-group>
                                    <label>Razão Social</label>
                                    <b-form-input
                                        v-model="fornecedor.nome"
                                        :disabled="desabilitarCampo"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="4" xl="4">
                                <b-form-group>
                                    <label>Nome Fantasia</label>
                                    <b-form-input
                                        v-model="fornecedor.nomeFantasia"
                                        :disabled="desabilitarCampo"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="5" lg="6" xl="4">
                                <b-form-group>
                                    <label class="required">e-mail</label>
                                    <b-form-input
                                        type="text"
                                        v-model="fornecedor.email"
                                        @input="$v.fornecedor.email.$touch()"
                                        :state="
                                            $v.fornecedor.email.$error
                                                ? false
                                                : null
                                        "
                                    ></b-form-input>
                                    <b-form-invalid-feedback
                                        >Forneça um email
                                        válido</b-form-invalid-feedback
                                    >
                                </b-form-group>
                            </b-col>
                            <b-col sm="12" md="4" lg="6">
                                <b-form-group>
                                    <label>Telefone</label>
                                    <b-form-input
                                        maxlength="15"
                                        type="text"
                                        v-model="fornecedor.telefone"
                                        v-mask="[
                                            '(##) ####-####',
                                            '(##) #####-####'
                                        ]"
                                    ></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <h5 class="heading-1 mt-2">
                            <span>ENDEREÇO</span>
                        </h5>
                        <app-endereco-form
                            v-model="endereco"
                        ></app-endereco-form>
                    </b-card-body>
                    <b-card-footer>
                        <b-button
                            variant="primary"
                            @click.stop="confirmarSalvar()"
                            class="mr-2"
                            v-if="mostrarBtnSalvar"
                        >
                            <i class="fa fa-save"></i> Salvar
                        </b-button>
                        <b-button variant="danger" @click.stop="cancelar()">
                            <span>
                                <i class="fa fa-history mr-2"></i> Cancelar
                            </span>
                        </b-button>
                        <div class="float-right">
                            <label class="required ml-3 pt-2"></label>
                            <label class="ml-2 pt-2">Campos Obrigatórios</label>
                        </div>
                    </b-card-footer>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators'
import EnderecoForm from './../../../shared/components/EnderecoForm'
import DadosCadastraisServicos from './DadosCadastraisServicos'
import FornecedoresServicos from '../../fornecedores/FornecedoresServicos';

export default {
    data() {
        return {
            fornecedor: {},
            endereco: {},
            operacao: 'ATUALIZAR',
            erros: [],
            logo: {
                base64: null,
                file: null,
                preview: 'img/placeholder-logo.png'
            },
            logoError: null,
            originalDadosCadastraisDto: {},
            dataLoaded: false,
            logoChanged: false
        }
    },

    watch: {},

    created() {
        this.obterFornecedor()
    },

    methods: {
         handleLogoChange(event) {
            const file = event.target.files[0]
            if (!file) {
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
                this.logoError = null;
                return;
            }

            this.logoError = null;

            // File type validation (PNG and SVG allowed)
            const allowedTypes = ['image/png', 'image/svg+xml'];
            if (!allowedTypes.includes(file.type)) {
                this.$toast.error('Formato de arquivo não suportado. Por favor, envie apenas imagens PNG e SVG.', 'Erro', this.$toastConfig.error);
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
                return;
            }

            // File size validation (Max 2MB)
            const maxFileSize = 2 * 1024 * 1024; // 2MB
            if (file.size > maxFileSize) {
                const fileSizeMB = (file.size / (1024 * 1024)).toFixed(2);
                this.$toast.error(`O arquivo selecionado é muito grande (${fileSizeMB} MB). O limite máximo permitido é de 2MB.`, 'Erro', this.$toastConfig.error);
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
                return;
            }

            const reader = new FileReader()
            reader.onload = (e) => {
                const img = new Image()
                img.onload = () => {
                    // Image resolution validation (Max 1024x1024px)
                    const maxResolution = 1024;
                    if (img.width > maxResolution || img.height > maxResolution) {
                        this.$toast.error(`A resolução da imagem excede o limite permitido de ${maxResolution}x${maxResolution} pixels.`, 'Erro', this.$toastConfig.error);
                        this.logo.preview = 'img/placeholder-logo.png';
                        this.logo.base64 = null;
                        return;
                    } else {
                        this.logo.preview = e.target.result
                        this.logo.base64 = e.target.result
                        this.logoChanged = true;
                    }
                }
                img.onerror = () => {
                    this.$toast.error('Não foi possível carregar a imagem selecionada. O arquivo pode estar corrompido ou o formato é inválido.', 'Erro', this.$toastConfig.error);
                    this.logo.preview = 'img/placeholder-logo.png';
                    this.logo.base64 = null;
                };
                img.src = e.target.result
            }
            reader.onerror = () => {
                this.$toast.error('Não foi possível ler o arquivo. Tente novamente mais tarde.', 'Erro', this.$toastConfig.error);
                this.logo.preview = 'img/placeholder-logo.png';
                this.logo.base64 = null;
            };
            reader.readAsDataURL(file)
        },

        triggerLogoUpload() {
            if (this.fornecedor.logo && this.logo.preview && this.logo.preview !== 'img/placeholder-logo.png') {
                this.$swal({
                    title: 'Atenção',
                    html: 'Ao selecionar uma nova logomarca, a anterior será substituída permanentemente nos novos documentos.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar'
                }).then(result => {
                    if (result.value) {
                        this.$refs.logoFileInput.click();
                    }
                })
            } else {
                this.$refs.logoFileInput.click();
            }
        },

        removeLogo() {
            this.logo.file = null;
            this.logo.base64 = null;
            this.logo.preview = 'img/placeholder-logo.png';
            this.fornecedor.logo = null;
            this.logoError = null;
            if (this.$refs.logoFileInput) {
                this.$refs.logoFileInput.value = '';
            }
            this.logoChanged = true;
        },

        cancelar() {
            this.$emit('obterDadosCadastrais')
            this.$router.push({ name: 'FornecedorDadosCadastrais' })
        },

        obterFornecedor() {
            this.$store.dispatch('addRequest')
            DadosCadastraisServicos.obterDados().then(response => {
                if (response) {
                    if (response.success) {
                        this.fornecedor = response.data
                        this.normalizarFornecedor()
                        if (this.fornecedor.logo) {
                            this.logo.preview = this.fornecedor.logo
                            this.logo.base64 = this.fornecedor.logo.split(',')[1]
                        }

                        this.originalDadosCadastraisDto = this.criarDadosCadastraisDto(this.fornecedor, this.endereco)
                        this.dataLoaded = true;
                        this.logoChanged = false;

                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        normalizarFornecedor() {
            this.fornecedor.cpfCnpj = this.$maskCpfCnpj(this.fornecedor.cpfCnpj)
            this.fornecedor.telefone = this.$maskTelefone(
                this.fornecedor.telefone
            )
            this.fornecedor.cep = this.$maskCep(this.fornecedor.cep)
            this.endereco = {
                logradouro: this.fornecedor.logradouro.toUpperCase(),
                numero: this.fornecedor.numero,
                complemento: this.fornecedor.complemento
                    ? this.fornecedor.complemento.toUpperCase()
                    : this.fornecedor.complemento,
                bairro: this.fornecedor.bairro.toUpperCase(),
                cidade: this.fornecedor.cidade.toUpperCase(),
                uf: this.fornecedor.uf,
                cep: this.fornecedor.cep
            }
        },

        confirmarSalvar() {
            const showSaveConfirmation = () => {
                this.$swal({
                    title: 'Atualização Cadastral',
                    html: `Confirma a solicitação para atualização cadastral?`,
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Não'
                }).then(result => {
                    if (result.value) {
                        this.salvar()
                    }
                })
            }

            if (this.fornecedor.logo && this.logo.file) {
                this.$swal({
                    title: 'Atenção',
                    html: 'Ao salvar, a logomarca anterior será substituída permanentemente nos novos documentos.',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Continuar',
                    cancelButtonText: 'Cancelar'
                }).then(result => {
                    if (result.value) {
                        showSaveConfirmation();
                    }
                })
            } else {
                showSaveConfirmation();
            }
        },

        criarDadosCadastraisDto(fornecedor, endereco) {
            return {
                email: fornecedor.email,
                telefone: fornecedor.telefone.apenasNumeros(),
                logradouro: endereco.logradouro,
                numero: endereco.numero,
                complemento: endereco.complemento ? endereco.complemento.toUpperCase() : endereco.complemento,
                bairro: endereco.bairro.toUpperCase(),
                cidade: endereco.cidade.toUpperCase(),
                uf: endereco.uf,
                cep: endereco.cep.apenasNumeros()
            };
        },

        salvar() {
            if (!this.dataLoaded) {
                this.$toast.error('Os dados ainda estão a ser carregados. Por favor, aguarde.', 'Erro', this.$toastConfig.error);
                return;
            }
            
            const dadosCadastraisDto = this.criarDadosCadastraisDto(this.fornecedor, this.endereco)
            const dadosCadastraisChanged = JSON.stringify(dadosCadastraisDto) !== JSON.stringify(this.originalDadosCadastraisDto)

            if (!dadosCadastraisChanged && !this.logoChanged) {
                this.$toast.info('Nenhuma alteração para salvar.', 'Informação', this.$toastConfig.info);
                return;
            }

            this.$store.dispatch('addRequest')

            const promises = [];

            if (dadosCadastraisChanged) {
                promises.push(DadosCadastraisServicos.atualizar(dadosCadastraisDto));
            }

            if (this.logoChanged) {
                const cpfCnpj = this.fornecedor.cpfCnpj.apenasNumeros()
                promises.push(FornecedoresServicos.atualizarLogo(cpfCnpj, this.logo.preview));
            }

            Promise.all(promises)
                .then(responses => {
                    const errors = responses.reduce((acc, response) => {
                        if (response && !response.success) {
                            acc.push(...response.errors);
                        }
                        return acc;
                    }, []);

                    if (errors.length > 0) {
                        this.erros = errors;
                    } else {
                        const apenasLogoAlterada = this.logoChanged && !dadosCadastraisChanged
                        const swalConfig = apenasLogoAlterada
                            ? {
                                title: 'Logomarca atualizada com sucesso',
                                icon: 'success'
                            }
                            : {
                                title: 'Solicitação de atualização realizada com sucesso',
                                html: 'Após o processamento da sua solicitação seus dados serão atualizados na base de dados do SUAPE.',
                                icon: 'success'
                            }
                        this.$swal(swalConfig).then(() => {
                            this.obterFornecedor();
                            this.cancelar();
                        });
                    }
                })
                .catch(error => {
                    this.erros = error.errors ? error.errors : ['Ocorreu um erro ao salvar.'];
                })
                .finally(() => {
                    this.$store.dispatch('removeRequest')
                });
        }
    },

    computed: {
        mostrarBtnSalvar() {
            return !this.$v.$invalid && this.endereco.valido && !this.logoError
        },

        desabilitarCampo() {
            return true
        }
    },

    validations: {
        fornecedor: {
            email: {
                required,
                email
            }
        },
        logo: {
            preview: {
                logoCarregada: (value) => !!value && value !== 'img/placeholder-logo.png'
            }
        }
    },

    components: {
        appEnderecoForm: EnderecoForm
    }
}
</script>
